module.exports = __webpack_public_path__ + "static/offer-illustration-416d4aa3cfe9d90e257a9d611889179a.svg";